import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=653f6ce1&scoped=true"
import script from "./Fade.vue?vue&type=script&lang=js"
export * from "./Fade.vue?vue&type=script&lang=js"
import style0 from "./Fade.vue?vue&type=style&index=0&id=653f6ce1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f6ce1",
  null
  
)

export default component.exports